<div class="input-group">
  <input #field
         class="form-control"
         [type]="showLookup ? 'hidden' : 'text'"
         [ngModel]="innerValue"
         [maxlength]="maxlength"
         (ngModelChange)="writeValue($event)">
  @if (showLookup) {
    @if (!innerValue) {
      <input type="text"
             class="form-control"
             [(ngModel)]="searchTerm"
             [disabled]="innerValue"
             [required]="required">
    }
    @if (innerValue) {
      <input
        type="text"
        class="form-control"
        [ngModel]="selected?.name"
        disabled
        [required]="required">
    }
    <div class="input-group-append">
      @if (innerValue) {
        <button
          type="button"
          class="clear-search"
          (click)="clear()">
          <i class="fas fa-times-circle"></i>
        </button>
      }
      @if (!innerValue) {
        <button
          class="btn btn-action"
          (click)="search()"
          type="button"
          [disabled]="!searchTerm">
          <reporter-icon icon="Search"></reporter-icon>
        </button>
      }
    </div>
    <div class="dropdown-menu w-100"
         [class.show]="branches?.length > 1 && !innerValue">
      @for (branch of branches; track branch; let index = $index) {
        <button
          class="dropdown-item"
          type="button"
          (click)="select(branch)">{{ branch.name }}
        </button>
      }
    </div>
    @if (branches?.length === 0) {
      <div class="w-100 alert alert-warning">
        Branch Not Found!
      </div>
    }
  }
</div>

